import { Switch } from "@headlessui/react";
import React from "react";
import { classNames } from "../../helpers";

export default function TwSwitch(props) {
  const { children, className = "", name = "", errors = {}, error = "", title = "", subTitle = "" } = props
  let inputProps = { ...props }
  delete inputProps.leftIcon
  delete inputProps.rightIcon
  delete inputProps.errors
  delete inputProps.title
  delete inputProps.subTitle
  if (name && errors[name] && errors[name] !== "") {
    props = {
      ...props,
      error: props.errors[name]
    };
  }
  let inputLableClass = "text-black/[0.6]"
  let inputClass = ""

  if (props.error && props.error !== "") {
    inputLableClass = "text-red-600"
    inputClass = "outline-red-300 ring-1 ring-red-300 focus:ring-red-600 focus-within:outline-red-600"
  }
  return (
    <div className={classNames("flex gap-2 md:gap-3 items-start min-w-0", className)}>
      <Switch
        {...inputProps}
        className={classNames("group relative inline-flex h-5 md:h-6 w-10 md:w-11 shrink-0 cursor-pointer rounded-full border-2 border-transparent bg-gray-200 transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-secondary focus:ring-offset-2 data-[checked]:bg-secondary",
          inputClass
        )}
      >
        <span
          aria-hidden="true"
          className="pointer-events-none inline-block size-4 md:size-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out group-data-[checked]:translate-x-5"
        />
      </Switch>
      <label as="span" className="[ml-2 md:ml-3] text-sm min-w-0 flex-auto">
        {title}
      </label>
    </div>
  );
}
